import { Calendar } from 'lucide-react';

const TABS = [
  { id: 'all', label: 'All', types: null },
  { id: 'subscriptions', label: 'Subscriptions', types: ['subscription'] },
  { id: 'boosts', label: 'Boosts & Listings', types: ['boost', 'plus_listing'] },
  { id: 'purchases', label: 'Purchases', types: ['transaction_buyer'] },
  { id: 'sales', label: 'Sales (fees)', types: ['transaction_seller_fee'] },
];

export function BillingFilters({ activeTab, onTabChange, dateFrom, dateTo, onDateChange }) {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab)}
            data-testid={`billing-tab-${tab.id}`}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors border ${
              activeTab === tab.id
                ? 'bg-[#1E3A5F] text-white border-[#1E3A5F]'
                : 'bg-[var(--theme-card)] text-[var(--theme-text-primary)] border-[var(--theme-border)] hover:bg-[var(--theme-hover)]'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap items-center gap-3 text-sm">
        <span className="flex items-center gap-1 text-[var(--theme-text-secondary)]">
          <Calendar className="w-4 h-4" />
          Date range:
        </span>
        <input
          type="date"
          value={dateFrom || ''}
          onChange={(e) => onDateChange({ from: e.target.value || null, to: dateTo })}
          className="px-3 py-1.5 rounded-lg border border-[var(--theme-border)] bg-[var(--theme-card)] text-[var(--theme-text-primary)]"
          data-testid="billing-date-from"
        />
        <span className="text-[var(--theme-text-secondary)]">to</span>
        <input
          type="date"
          value={dateTo || ''}
          onChange={(e) => onDateChange({ from: dateFrom, to: e.target.value || null })}
          className="px-3 py-1.5 rounded-lg border border-[var(--theme-border)] bg-[var(--theme-card)] text-[var(--theme-text-primary)]"
          data-testid="billing-date-to"
        />
        {(dateFrom || dateTo) && (
          <button
            onClick={() => onDateChange({ from: null, to: null })}
            className="text-[#C9956C] hover:underline"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
}

export { TABS };
